const ko = {
    'name' :  '성명'
}
export default ko